import React, { useRef, useMemo } from 'react';

const Timeline = ({ duration, currentTime, events, onSeek }) => {
  const progressBarRef = useRef(null);

  const handleTimelineClick = (e) => {
    if (!progressBarRef.current || duration === 0) return;
    const rect = progressBarRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = Math.min(Math.max(x / rect.width, 0), 1);
    onSeek(percentage * duration);
  };

  const progressPercent = useMemo(() => {
    if (duration === 0) return 0;
    return (currentTime / duration) * 100;
  }, [currentTime, duration]);

  return (
    <div className="w-full h-12 flex items-center px-2 group cursor-pointer" onClick={handleTimelineClick}>
      {/* Track Background */}
      <div className="relative w-full h-2 bg-zinc-800 rounded-sm overflow-visible" ref={progressBarRef}>

        {/* Progress Fill */}
        <div
          className="absolute top-0 left-0 h-full bg-amber-400 transition-all duration-100 ease-linear z-10"
          style={{ width: `${progressPercent}%` }}
        >
          {/* Playhead Handle */}
          <div className="absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-amber-400 border-2 border-black rounded-full shadow-lg scale-0 group-hover:scale-100 transition-transform duration-200" />
        </div>

        {/* Event Markers (Ticks) */}
        {events.map((event) => {
           if (duration === 0) return null;
           const leftPercent = (event.start_sec / duration) * 100;
           const widthPercent = ((event.end_sec - event.start_sec) / duration) * 100;

           return (
             <div
                key={event.id}
                className="absolute top-0 h-full bg-yellow-600 opacity-40 hover:opacity-80 hover:bg-yellow-400 z-0 transition-opacity"
                style={{ left: `${leftPercent}%`, width: `${widthPercent}%` }}
                title={`${event.title} (${event.start_sec}s - ${event.end_sec}s)`}
             />
           );
        })}

        {/* Hover Highlight */}
        <div className="absolute top-0 h-full bg-white opacity-0 group-hover:opacity-5 w-full pointer-events-none"></div>
      </div>
    </div>
  );
};

export default Timeline;
